import type { TOC } from '@ember/component/template-only';
import Icon from '../components/icon';
import MailCheckIcon from '~icons/lucide/mail-check';
import MailXIcon from '~icons/lucide/mail-x';

interface Signature {
  Args: {
    model: { error?: string };
  };
}

const VerifiedTemplate: TOC<Signature> = <template>
  <div class="flex min-h-[50vh] flex-col items-center justify-center py-12">
    {{#if @model.error}}
      <div class="text-error/60 mb-4">
        <Icon @icon={{MailXIcon}} class="inline-block h-20 w-20" />
      </div>

      <h1 class="mb-2 text-xl font-semibold">Verification link expired</h1>

      <p class="text-base-content/60 max-w-md text-center">
        This link is no longer valid. Open the Saive app and tap
        <span class="font-semibold">Resend</span>
        to get a new one.
      </p>
    {{else}}
      <div class="text-success/70 mb-4">
        <Icon @icon={{MailCheckIcon}} class="inline-block h-20 w-20" />
      </div>

      <h1 class="mb-2 text-xl font-semibold">Email verified</h1>

      <p class="text-base-content/60 max-w-md text-center">
        You're all set — you can return to the Saive app.
      </p>
    {{/if}}
  </div>
</template>;

export default VerifiedTemplate;
